export const KEYPRESS:string = "onkeypress";

export const ONCHANGE:string = "onchange";

export const ONCLICK:string = "onclick";

export const ONKEYUP:string = "onkeyup";

export const ONBLUR:string = "onblur";

export const ONFOCUS:string = "onfocus";

export const ELEMENT_VALUE:string = "value";

export const BLUR:string = "blur";

export const FOCUS:string = "focus";

export const CHANGE: string = "change";

export const KEY_DOWN: string = "keydown";

export const KEY_PRESS: string = "keypress";

export const PASTE: string = "paste";

